export const costDocumentImportBookingFilesFilter = {
  name: "costDocumentImportBookingFilesFilter",
  criterions: [
    {
      monthToBack: 1,
      fromDataType: 4,
      toDataType: 0,
      value: {
        fromIsSelected: true,
        fromValue: "2021-01-01T00:00:00",
        toIsSelected: false,
        toValue: "2021-02-19T23:59:59.999",
      },
      type: "DateFromToCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Okres",
      propertyName: "Period",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 2,
      label: "Nr biletu/rez.",
      propertyName: "TicketNumber",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 3,
      label: "Nr. dokumentu",
      propertyName: "DocumentNumber",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 200,
      value: null,
      uniqueId: null,
      type: "AutocompleteTextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 4,
      label: "Kontrahent",
      propertyName: "PropertyName_ContractorsAutocompleteOnlyBuyers",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 1,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: "Hotel",
          stringValue: "Hotele",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        intKey: 0,
        stringKey: "Hotel",
        stringValue: "Hotele",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 5,
      label: "Typ rezerwacji",
      propertyName: "Tab",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      value: true,
      type: "BooleanCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 6,
      label: "Rez. z załącznikiem PDF",
      propertyName: "HasFileCriterion",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      value: true,
      type: "BooleanCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 7,
      label: "Niesparowane rez.",
      propertyName: "UnpairBooking",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
  ],
};
